/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Meeting_DeclinedInputs */

const th_meeting_declined = /** @type {(inputs: Meeting_DeclinedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ปฏิเสธแล้ว`)
};

const en_meeting_declined = /** @type {(inputs: Meeting_DeclinedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Declined`)
};

const ja_meeting_declined = /** @type {(inputs: Meeting_DeclinedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`辞退済み`)
};

const zh_meeting_declined = /** @type {(inputs: Meeting_DeclinedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`已拒绝`)
};

const es_meeting_declined = /** @type {(inputs: Meeting_DeclinedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rechazada`)
};

const pt_meeting_declined = /** @type {(inputs: Meeting_DeclinedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Recusada`)
};

const id_meeting_declined = /** @type {(inputs: Meeting_DeclinedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ditolak`)
};

const fr_meeting_declined = /** @type {(inputs: Meeting_DeclinedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Refusée`)
};

const tl_meeting_declined = /** @type {(inputs: Meeting_DeclinedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tinanggihan`)
};

const vi_meeting_declined = /** @type {(inputs: Meeting_DeclinedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đã từ chối`)
};

const ko_meeting_declined = /** @type {(inputs: Meeting_DeclinedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`거절함`)
};

const de_meeting_declined = /** @type {(inputs: Meeting_DeclinedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abgesagt`)
};

const ru_meeting_declined = /** @type {(inputs: Meeting_DeclinedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Отказ`)
};

const tr_meeting_declined = /** @type {(inputs: Meeting_DeclinedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reddedildi`)
};

const it_meeting_declined = /** @type {(inputs: Meeting_DeclinedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rifiutato`)
};

const pl_meeting_declined = /** @type {(inputs: Meeting_DeclinedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Odmówiono`)
};

const uk_meeting_declined = /** @type {(inputs: Meeting_DeclinedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Відхилено`)
};

const hi_meeting_declined = /** @type {(inputs: Meeting_DeclinedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`अस्वीकृत`)
};

const ar_meeting_declined = /** @type {(inputs: Meeting_DeclinedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`مرفوضة`)
};

const ms_meeting_declined = /** @type {(inputs: Meeting_DeclinedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ditolak`)
};

const bn_meeting_declined = /** @type {(inputs: Meeting_DeclinedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`প্রত্যাখ্যাত`)
};

const zh_tw2_meeting_declined = /** @type {(inputs: Meeting_DeclinedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`已婉拒`)
};

const zh_hk2_meeting_declined = /** @type {(inputs: Meeting_DeclinedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`已婉拒`)
};

const ur_meeting_declined = /** @type {(inputs: Meeting_DeclinedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`انکار شدہ`)
};

const fa_meeting_declined = /** @type {(inputs: Meeting_DeclinedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`رد شد`)
};

const sw_meeting_declined = /** @type {(inputs: Meeting_DeclinedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Imekataliwa`)
};

const nl_meeting_declined = /** @type {(inputs: Meeting_DeclinedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Afgewezen`)
};

/**
* | output |
* | --- |
* | "Declined" |
*
* @param {Meeting_DeclinedInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const meeting_declined = /** @type {((inputs?: Meeting_DeclinedInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Meeting_DeclinedInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_meeting_declined(inputs)
	if (locale === "ja") return ja_meeting_declined(inputs)
	if (locale === "zh") return zh_meeting_declined(inputs)
	if (locale === "es") return es_meeting_declined(inputs)
	if (locale === "pt") return pt_meeting_declined(inputs)
	if (locale === "id") return id_meeting_declined(inputs)
	if (locale === "fr") return fr_meeting_declined(inputs)
	if (locale === "tl") return tl_meeting_declined(inputs)
	if (locale === "vi") return vi_meeting_declined(inputs)
	if (locale === "ko") return ko_meeting_declined(inputs)
	if (locale === "de") return de_meeting_declined(inputs)
	if (locale === "ru") return ru_meeting_declined(inputs)
	if (locale === "tr") return tr_meeting_declined(inputs)
	if (locale === "it") return it_meeting_declined(inputs)
	if (locale === "pl") return pl_meeting_declined(inputs)
	if (locale === "uk") return uk_meeting_declined(inputs)
	if (locale === "hi") return hi_meeting_declined(inputs)
	if (locale === "ar") return ar_meeting_declined(inputs)
	if (locale === "ms") return ms_meeting_declined(inputs)
	if (locale === "bn") return bn_meeting_declined(inputs)
	if (locale === "zh-TW") return zh_tw2_meeting_declined(inputs)
	if (locale === "zh-HK") return zh_hk2_meeting_declined(inputs)
	if (locale === "ur") return ur_meeting_declined(inputs)
	if (locale === "fa") return fa_meeting_declined(inputs)
	if (locale === "sw") return sw_meeting_declined(inputs)
	if (locale === "nl") return nl_meeting_declined(inputs)
	return en_meeting_declined(inputs)
});